export default __webpack_public_path__ + "static/media/undraw_video_streaming_re_v3qg.9ea36270.svg";